import React from 'react';
import PropTypes from 'prop-types';
import SpinnerSource from './SpinnerSource.inner';

const Spinner = ({ size, variant }) => {
  const CurrentSpinner =
    SpinnerSource[`${variant}`] || SpinnerSource['primary'];

  const spinnerSize = {
    sm: {
      width: 24,
      height: 24,
    },
    md: {
      width: 48,
      height: 48,
    },
  };

  return <CurrentSpinner {...(spinnerSize[size] || spinnerSize.md)} />;
};

Spinner.defaultProps = {
  size: 'md',
  variant: 'primary',
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['md', 'sm']),
  variant: PropTypes.oneOf(['primary', 'neutral']),
};

export default Spinner;
